import { render } from "./aboutMe.vue?vue&type=template&id=33a136bc"
import script from "./aboutMe.vue?vue&type=script&lang=js"
export * from "./aboutMe.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__